import AppContent from './AppContent';
import RootProviders from './RootProviders';

function App() {
  return (
    <RootProviders>
      <AppContent />
    </RootProviders>
  );
}

export default App;